function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{opacity:0;}\n\t.st1{fill:#FF1730;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_00000084518521257606042340000016297989823998498223_);}\n\t.st4{fill:url(#SVGID_00000034783515022001482500000007266314428227551650_);}\n\t.st5{fill:url(#SVGID_00000027590719250315796140000016939333862949672113_);}\n\t.st6{fill:url(#SVGID_00000037678100483555688310000006732410126708441013_);}\n\t.st7{fill:url(#SVGID_00000119825533132384215670000018159791753710737550_);}\n\t.st8{fill:#743E83;}\n\t.st9{fill:none;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "st0"
}, React.createElement("polygon", {
  className: "st1",
  points: "485.8,422 404.9,562.3 242.9,562.3 161.9,422 242.9,281.8 404.9,281.8  "
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  className: "st0"
}, React.createElement("polygon", {
  className: "st1",
  points: "730.2,281.8 649.2,422 487.2,422 406.3,281.8 487.2,141.5 649.2,141.5  "
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  className: "st0"
}, React.createElement("polygon", {
  className: "st1",
  points: "971.4,142.2 890.5,282.4 728.5,282.4 647.5,142.2 728.5,1.9 890.5,1.9  "
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  className: "st0"
}, React.createElement("polygon", {
  className: "st1",
  points: "728.6,563.7 647.6,704 485.7,704 404.7,563.7 485.7,423.5 647.6,423.5  "
}));

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  d: "M405.6,563.7H242l-0.4-0.8L160.2,422L242,280.4h163.6l0.4,0.8l81.4,140.9L405.6,563.7z M243.7,560.7h160.2 L484,422l-80.1-138.7H243.7L163.6,422L243.7,560.7z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st8",
  d: "M521.2,552.8c0.5,0.6,0.9,1.3,1.2,2.1s0.4,1.8,0.4,2.9c0,1.1-0.1,2-0.4,2.9s-0.7,1.6-1.2,2.2 c-0.5,0.6-1.2,1.1-1.9,1.3c-0.7,0.3-1.5,0.4-2.4,0.4c-0.9,0-1.7-0.1-2.4-0.4s-1.3-0.7-1.8-1.3c-0.5-0.6-0.9-1.3-1.2-2.1 s-0.4-1.8-0.4-2.9c0-1.1,0.1-2.1,0.4-2.9s0.7-1.5,1.2-2.1c0.5-0.6,1.1-1,1.8-1.3s1.5-0.5,2.4-0.5c0.9,0,1.7,0.2,2.4,0.5 S520.7,552.2,521.2,552.8z M520.9,557.8c0-0.9-0.1-1.6-0.3-2.3s-0.5-1.2-0.8-1.7c-0.3-0.5-0.8-0.8-1.3-1s-1-0.3-1.6-0.3 c-0.6,0-1.2,0.1-1.7,0.3c-0.5,0.2-0.9,0.6-1.3,1c-0.3,0.4-0.6,1-0.8,1.7s-0.3,1.4-0.3,2.3c0,1.7,0.4,3,1.1,3.9 c0.7,0.9,1.7,1.4,2.9,1.4s2.2-0.5,2.9-1.4C520.6,560.9,520.9,559.6,520.9,557.8z"
}), React.createElement("path", {
  className: "st8",
  d: "M527.5,564.6c-0.9,0-1.6-0.3-2.1-0.8c-0.5-0.5-0.8-1.3-0.8-2.4v-5.4h-1.1v-1.4h1.1v-2.8h1.7v2.8h3v1.4h-3v4.7 c0,0.5,0,0.9,0,1.2s0.1,0.5,0.2,0.8c0.1,0.2,0.3,0.4,0.5,0.5s0.5,0.2,0.9,0.2c0.3,0,0.5,0,0.8-0.1c0.3-0.1,0.4-0.1,0.5-0.2h0.1v1.5 c-0.3,0.1-0.6,0.2-0.9,0.2C528.1,564.5,527.8,564.6,527.5,564.6z"
}), React.createElement("path", {
  className: "st8",
  d: "M538.3,564.4h-1.7v-5.6c0-0.5,0-0.9-0.1-1.3c0-0.4-0.1-0.7-0.3-0.9c-0.1-0.2-0.3-0.4-0.6-0.5s-0.6-0.2-1-0.2 c-0.4,0-0.8,0.1-1.3,0.3c-0.4,0.2-0.9,0.5-1.3,0.9v7.3h-1.7v-13.7h1.7v4.9c0.5-0.4,1-0.8,1.5-1s1-0.4,1.5-0.4c1,0,1.7,0.3,2.3,1 c0.5,0.6,0.8,1.6,0.8,2.8V564.4z"
}), React.createElement("path", {
  className: "st8",
  d: "M544.9,564.6c-1.6,0-2.8-0.4-3.6-1.3s-1.3-2.1-1.3-3.8c0-1.6,0.4-2.9,1.3-3.8s1.9-1.4,3.3-1.4 c0.6,0,1.1,0.1,1.6,0.3s0.9,0.5,1.2,0.8s0.6,0.8,0.8,1.4c0.2,0.5,0.3,1.2,0.3,2v0.9h-6.8c0,1.1,0.3,2,0.9,2.6s1.4,0.9,2.4,0.9 c0.4,0,0.7,0,1.1-0.1s0.7-0.2,0.9-0.3c0.3-0.1,0.6-0.3,0.8-0.4s0.4-0.2,0.5-0.4h0.1v1.8c-0.2,0.1-0.4,0.2-0.7,0.3 c-0.3,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.6,0.2-0.9,0.2S545.3,564.6,544.9,564.6z M546.8,558.4c0-0.4-0.1-0.8-0.2-1.2 s-0.2-0.6-0.4-0.8c-0.2-0.2-0.4-0.4-0.7-0.6s-0.7-0.2-1.1-0.2c-0.4,0-0.8,0.1-1.1,0.2c-0.3,0.1-0.6,0.3-0.8,0.6 c-0.2,0.3-0.4,0.5-0.6,0.9c-0.1,0.3-0.2,0.7-0.2,1.1H546.8z"
}), React.createElement("path", {
  className: "st8",
  d: "M555.3,556.3L555.3,556.3c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0-0.3,0-0.5,0c-0.4,0-0.9,0.1-1.3,0.3s-0.9,0.5-1.2,0.9 v7h-1.7v-9.8h1.7v1.5c0.6-0.5,1.1-0.9,1.6-1.1c0.4-0.2,0.9-0.3,1.3-0.3c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0V556.3z"
}), React.createElement("path", {
  className: "st8",
  d: "M564.8,564.6c-0.7,0-1.3-0.1-1.8-0.3s-1-0.4-1.4-0.6v-1.9h0.1c0.1,0.1,0.3,0.2,0.5,0.4s0.4,0.3,0.8,0.4 c0.3,0.1,0.6,0.2,0.9,0.3s0.7,0.1,1.1,0.1c0.3,0,0.5,0,0.8-0.1c0.3-0.1,0.5-0.1,0.7-0.2c0.2-0.1,0.4-0.3,0.4-0.4s0.1-0.4,0.1-0.7 c0-0.4-0.1-0.7-0.3-0.9s-0.6-0.4-1.1-0.5c-0.2-0.1-0.5-0.1-0.8-0.2s-0.7-0.1-0.9-0.2c-0.8-0.2-1.3-0.6-1.6-1 c-0.3-0.5-0.5-1-0.5-1.6c0-0.9,0.3-1.6,1-2.2s1.6-0.8,2.7-0.8c0.5,0,1.1,0.1,1.6,0.2s1,0.3,1.4,0.5v1.8h-0.1 c-0.4-0.3-0.9-0.6-1.4-0.8s-1-0.3-1.6-0.3c-0.5,0-1,0.1-1.4,0.3s-0.6,0.6-0.6,1c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.6,0.4,1.1,0.5 c0.2,0.1,0.5,0.1,0.8,0.2c0.3,0.1,0.6,0.1,1,0.2c0.7,0.2,1.3,0.5,1.6,0.9s0.5,1,0.5,1.7c0,0.4-0.1,0.8-0.3,1.2 c-0.2,0.4-0.4,0.7-0.7,1c-0.4,0.3-0.7,0.5-1.2,0.7S565.5,564.6,564.8,564.6z"
}), React.createElement("path", {
  className: "st8",
  d: "M574.5,564.6c-1.6,0-2.8-0.4-3.6-1.3s-1.3-2.1-1.3-3.8c0-1.6,0.4-2.9,1.3-3.8s1.9-1.4,3.3-1.4 c0.6,0,1.1,0.1,1.6,0.3s0.9,0.5,1.2,0.8s0.6,0.8,0.8,1.4c0.2,0.5,0.3,1.2,0.3,2v0.9h-6.8c0,1.1,0.3,2,0.9,2.6s1.4,0.9,2.4,0.9 c0.4,0,0.7,0,1.1-0.1s0.7-0.2,0.9-0.3c0.3-0.1,0.6-0.3,0.8-0.4s0.4-0.2,0.5-0.4h0.1v1.8c-0.2,0.1-0.4,0.2-0.7,0.3 c-0.3,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.6,0.2-0.9,0.2S574.9,564.6,574.5,564.6z M576.4,558.4c0-0.4-0.1-0.8-0.2-1.2 s-0.2-0.6-0.4-0.8c-0.2-0.2-0.4-0.4-0.7-0.6s-0.7-0.2-1.1-0.2c-0.4,0-0.8,0.1-1.1,0.2c-0.3,0.1-0.6,0.3-0.8,0.6 c-0.2,0.3-0.4,0.5-0.6,0.9c-0.1,0.3-0.2,0.7-0.2,1.1H576.4z"
}), React.createElement("path", {
  className: "st8",
  d: "M584.9,556.3L584.9,556.3c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0-0.3,0-0.5,0c-0.4,0-0.9,0.1-1.3,0.3s-0.9,0.5-1.2,0.9 v7h-1.7v-9.8h1.7v1.5c0.6-0.5,1.1-0.9,1.6-1.1c0.4-0.2,0.9-0.3,1.3-0.3c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0V556.3z"
}), React.createElement("path", {
  className: "st8",
  d: "M593.9,554.6l-3.7,9.8h-1.5l-3.7-9.8h1.8l2.7,7.6l2.7-7.6H593.9z"
}), React.createElement("path", {
  className: "st8",
  d: "M596.9,552.9h-1.9v-1.7h1.9V552.9z M596.8,564.4h-1.7v-9.8h1.7V564.4z"
}), React.createElement("path", {
  className: "st8",
  d: "M603.2,564.6c-0.7,0-1.3-0.1-1.9-0.3c-0.6-0.2-1-0.5-1.5-0.9s-0.7-1-0.9-1.6c-0.2-0.6-0.3-1.4-0.3-2.3 c0-0.9,0.1-1.6,0.3-2.2s0.5-1.2,0.9-1.6s0.9-0.8,1.4-1c0.6-0.2,1.2-0.3,1.9-0.3c0.5,0,1.1,0.1,1.6,0.2c0.5,0.2,0.9,0.3,1.3,0.5v1.9 H606c-0.1-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.4-0.3-0.7-0.4c-0.2-0.1-0.5-0.2-0.8-0.3s-0.6-0.1-0.9-0.1c-0.9,0-1.5,0.3-2.1,1 c-0.5,0.6-0.8,1.6-0.8,2.7c0,1.2,0.2,2.1,0.8,2.7c0.5,0.6,1.2,1,2.1,1c0.5,0,1.1-0.1,1.5-0.3s0.9-0.5,1.3-0.9h0.1v1.9 c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.5,0.2-0.7,0.2c-0.3,0.1-0.5,0.1-0.8,0.2C603.8,564.6,603.5,564.6,603.2,564.6z"
}), React.createElement("path", {
  className: "st8",
  d: "M611.8,564.6c-1.6,0-2.8-0.4-3.6-1.3s-1.3-2.1-1.3-3.8c0-1.6,0.4-2.9,1.3-3.8s1.9-1.4,3.3-1.4 c0.6,0,1.1,0.1,1.6,0.3s0.9,0.5,1.2,0.8s0.6,0.8,0.8,1.4c0.2,0.5,0.3,1.2,0.3,2v0.9h-6.8c0,1.1,0.3,2,0.9,2.6s1.4,0.9,2.4,0.9 c0.4,0,0.7,0,1.1-0.1s0.7-0.2,0.9-0.3c0.3-0.1,0.6-0.3,0.8-0.4s0.4-0.2,0.5-0.4h0.1v1.8c-0.2,0.1-0.4,0.2-0.7,0.3 c-0.3,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.6,0.2-0.9,0.2C612.5,564.6,612.2,564.6,611.8,564.6z M613.8,558.4c0-0.4-0.1-0.8-0.2-1.2 s-0.2-0.6-0.4-0.8c-0.2-0.2-0.4-0.4-0.7-0.6s-0.7-0.2-1.1-0.2c-0.4,0-0.8,0.1-1.1,0.2c-0.3,0.1-0.6,0.3-0.8,0.6 c-0.2,0.3-0.4,0.5-0.6,0.9c-0.1,0.3-0.2,0.7-0.2,1.1H613.8z"
}), React.createElement("path", {
  className: "st8",
  d: "M619.7,564.6c-0.7,0-1.3-0.1-1.8-0.3c-0.6-0.2-1-0.4-1.4-0.6v-1.9h0.1c0.1,0.1,0.3,0.2,0.5,0.4 c0.2,0.1,0.4,0.3,0.8,0.4c0.3,0.1,0.6,0.2,0.9,0.3c0.3,0.1,0.7,0.1,1,0.1c0.3,0,0.5,0,0.8-0.1c0.3-0.1,0.5-0.1,0.7-0.2 c0.2-0.1,0.4-0.3,0.4-0.4c0.1-0.2,0.1-0.4,0.1-0.7c0-0.4-0.1-0.7-0.3-0.9s-0.6-0.4-1.1-0.5c-0.2-0.1-0.5-0.1-0.8-0.2 s-0.7-0.1-0.9-0.2c-0.8-0.2-1.3-0.6-1.6-1c-0.3-0.5-0.5-1-0.5-1.6c0-0.9,0.3-1.6,1-2.2s1.6-0.8,2.7-0.8c0.5,0,1.1,0.1,1.6,0.2 s1,0.3,1.4,0.5v1.8h-0.1c-0.4-0.3-0.9-0.6-1.4-0.8c-0.5-0.2-1-0.3-1.6-0.3c-0.5,0-1,0.1-1.4,0.3s-0.6,0.6-0.6,1 c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.6,0.4,1.1,0.5c0.2,0.1,0.5,0.1,0.8,0.2c0.3,0.1,0.6,0.1,1,0.2c0.7,0.2,1.3,0.5,1.6,0.9 s0.5,1,0.5,1.7c0,0.4-0.1,0.8-0.3,1.2c-0.2,0.4-0.4,0.7-0.7,1c-0.4,0.3-0.7,0.5-1.2,0.7C620.9,564.5,620.4,564.6,619.7,564.6z"
}));

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 559.4,
  y: 521.2,
  className: "st9",
  width: 6,
  height: 0
});

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var SvgZenonServicesOpacity = function SvgZenonServicesOpacity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1134.1 704",
    style: {
      enableBackground: "new 0 0 1134.1 704"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 513.21,
    y1: 22.2298,
    x2: 840.42,
    y2: 22.2298,
    gradientTransform: "matrix(1 0 0 -1 -353.04 444.2698)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FC1C6"
    }
  }), React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#6BB8C3"
    }
  }), React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#609EBB"
    }
  }), React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#4D75AD"
    }
  }), React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#343C9A"
    }
  }), React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#2C2994"
    }
  })), _ref7, React.createElement("linearGradient", {
    id: "SVGID_00000135683618988481162590000015998526648272157101_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 421.6648,
    x2: 244.54,
    y2: 421.6648,
    gradientTransform: "matrix(1 0 0 -1 0 703.8898)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FC1C6"
    }
  }), React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#6BB8C3"
    }
  }), React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#609EBB"
    }
  }), React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#4D75AD"
    }
  }), React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#343C9A"
    }
  }), React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#2C2994"
    }
  })), React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000135683618988481162590000015998526648272157101_)"
    },
    points: "162.7,423.5 0,423.5 0,420.5  161,420.5 241.1,281.9 160.6,142.4 163.2,140.9 244.5,281.9 "
  }), React.createElement("linearGradient", {
    id: "SVGID_00000137854228141315677860000018411581971691735690_",
    gradientUnits: "userSpaceOnUse",
    x1: 756.06,
    y1: 162.3948,
    x2: 1083.27,
    y2: 162.3948,
    gradientTransform: "matrix(1 0 0 -1 -353.04 444.2698)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FC1C6"
    }
  }), React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#6BB8C3"
    }
  }), React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#609EBB"
    }
  }), React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#4D75AD"
    }
  }), React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#343C9A"
    }
  }), React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#2C2994"
    }
  })), React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137854228141315677860000018411581971691735690_)"
    },
    d: "M648.4,423.6H484.8l-0.4-0.8L403,281.9 l81.8-141.7h163.6l0.4,0.7l81.4,140.9l-0.4,0.8L648.4,423.6z M486.5,420.6h160.2l80.1-138.7l-80.1-138.7H486.6l-80.1,138.7 L486.5,420.6z"
  }), React.createElement("linearGradient", {
    id: "SVGID_00000018203411162001767960000016592052431615223448_",
    gradientUnits: "userSpaceOnUse",
    x1: 756.06,
    y1: -118.0052,
    x2: 1083.27,
    y2: -118.0052,
    gradientTransform: "matrix(1 0 0 -1 -353.04 444.2698)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FC1C6"
    }
  }), React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#6BB8C3"
    }
  }), React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#609EBB"
    }
  }), React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#4D75AD"
    }
  }), React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#343C9A"
    }
  }), React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#2C2994"
    }
  })), React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018203411162001767960000016592052431615223448_)"
    },
    d: "M648.4,704H484.8l-0.4-0.8L403,562.3 l81.8-141.7h163.6l0.4,0.8l81.4,140.9l-0.4,0.8L648.4,704z M486.5,701h160.2l80.1-138.7l-80.1-138.7H486.6l-80.1,138.7L486.5,701z"
  }), React.createElement("linearGradient", {
    id: "SVGID_00000173153356264367758990000017662091192566010251_",
    gradientUnits: "userSpaceOnUse",
    x1: 998.91,
    y1: 302.5798,
    x2: 1326.1199,
    y2: 302.5798,
    gradientTransform: "matrix(1 0 0 -1 -353.04 444.2698)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FC1C6"
    }
  }), React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#6BB8C3"
    }
  }), React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#609EBB"
    }
  }), React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#4D75AD"
    }
  }), React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#343C9A"
    }
  }), React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#2C2994"
    }
  })), React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173153356264367758990000017662091192566010251_)"
    },
    d: "M891.3,283.4H727.7l-0.4-0.7l-81.4-141 l0.4-0.8L727.7,0h163.6l0.4,0.7l81.4,140.9l-0.4,0.8L891.3,283.4z M729.4,280.4h160.2l80.1-138.7L889.6,3H729.4l-80.1,138.7 L729.4,280.4z"
  }), React.createElement("linearGradient", {
    id: "SVGID_00000068638459598631786620000012298958508958878374_",
    gradientUnits: "userSpaceOnUse",
    x1: 888.71,
    y1: 422.4398,
    x2: 1134.12,
    y2: 422.4398,
    gradientTransform: "matrix(1 0 0 -1 0 703.8898)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FC1C6"
    }
  }), React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#6BB8C3"
    }
  }), React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#609EBB"
    }
  }), React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#4D75AD"
    }
  }), React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#343C9A"
    }
  }), React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#2C2994"
    }
  })), React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000068638459598631786620000012298958508958878374_)"
    },
    points: "970.1,422.8 888.7,281.8  889.1,281.1 970.5,140.1 1134.1,140.1 1134.1,143.1 972.2,143.1 892.2,281.8 972.7,421.3 "
  }), _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgZenonServicesOpacity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Zenon-Services-Opacity.a9e07fd8.svg";
export { ForwardRef as ReactComponent };